import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import LedgerCreate from '@app/views/Ledger/LedgerCreate';
import { memo } from 'react';

export default memo(
  withIfUser(LedgerCreate)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
